import React, { useState } from "react";
import { Form, Button, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DateTimePicker from "react-datetime-picker";
import { getStats } from "../../../services/Results";
import RecordsTable from "./RecordsTable";
import {
  serviceActions,
  useServiceReducer,
} from "../../../reducers/serviceReducer";
import InfoBox from "../../system/InfoBox";

export default function RecordsBox(props) {
  const metalOptions = [
    { value: -1, label: "Select a metal" },
    {
      value: "aluminium",
      label: "Aluminium",
    },
    { value: "copper", label: "Copper" },
    { value: "nickel", label: "Nickel" },
    { value: "zinc", label: "Zinc" },
    { value: "lead", label: "Lead" },
    { value: "Tin", label: "Tin" },
  ];
  const [serviceState, serviceDispatch] = useServiceReducer();
  const [stats, setStats] = useState(null);
  const [fromDate, setFromDate] = useState(() => {
    let d = new Date();
    d.setDate(d.getDate() - 1);
    return d;
  });
  const [toDate, setToDate] = useState(new Date());
  const [metal, setMetal] = useState(null);
  async function load() {
    serviceDispatch({ type: serviceActions.LOADING });
    try {
      const result = await getStats(
        props.engine,
        metal,
        fromDate.getTime(),
        toDate.getTime()
      );
      setStats(result.Items);
      serviceDispatch({ type: serviceActions.SUCCESS });
    } catch (err) {
      console.log("error", err);
      serviceDispatch({ type: serviceActions.ERROR, payload: err.message });
    }
  }

  return (
    <div className="card mb-4">
      <div className="card-header">
        <FontAwesomeIcon icon="table" className="mr-1" />
        Analysis Results
        <Form.Row>
          <Form.Group as={Col} controlId="formGridCity">
            <Form.Label>From:</Form.Label>
            <DateTimePicker
              maxDetail="second"
              className="form-control"
              onChange={setFromDate}
              value={fromDate}
            />
          </Form.Group>

          <Form.Group as={Col} controlId="formGridState">
            <Form.Label>To:</Form.Label>
            <DateTimePicker
              maxDetail="second"
              className="form-control"
              onChange={setToDate}
              value={toDate}
            />
          </Form.Group>
          <Form.Group as={Col} controlId="formGridState">
            <Form.Label>Choose Metal:</Form.Label>
            <select
              onChange={(e) => {
                setMetal(e.target.value);
              }}
              className="form-control"
            >
              {metalOptions.map((mo) => {
                return (
                  <option key={`ov_${mo.value}`} value={mo.value}>
                    {mo.label}
                  </option>
                );
              })}
            </select>
          </Form.Group>
        </Form.Row>
        <div className="float-right mr-1">
          <div>
            <div className="float-left mr-2 mt-1">
              <div>
                <Button
                  variant="outline-primary"
                  disabled={serviceState.loading}
                  className="ml-1"
                  onClick={() => {
                    load();
                  }}
                >
                  Show results
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body">
        {stats ? (
          stats.length ? (
            <RecordsTable title="Results" data={stats} />
          ) : (
            <InfoBox
              type="info"
              keyv="rtn"
              message="No results found for the given time period"
            />
          )
        ) : null}
      </div>
    </div>
  );
}
